export default __webpack_public_path__ + "static/media/img01.ce2447b6.svg";